import { storage } from './storage';

export function setStorage(key, value) {
    return storage().set(key, value);
}
